import { fetchJson } from '../store/fetch';

export async function fetchActiveOsasqResendDate(patientId: string) {
    const getSendDateOfLastOsasqResult = await fetchJson(
        `/api/requests/getSendDateOfLastOsasq?patientId=${patientId}`,
        'GET',
        undefined,
        [],
        [400]
    );

    return getSendDateOfLastOsasqResult.json.date ?? null;
}
